import { render, staticRenderFns } from "./MinePage.vue?vue&type=template&id=2512fca6"
import script from "./MinePage.vue?vue&type=script&lang=js"
export * from "./MinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports